/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import { apiUrl, headerconfig } from "../Settings/Config";
import {
  showLoader,
  userID,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  showContaimerLoader,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import isEmail from "validator/lib/isEmail";
var module = "shipto/";
var moduleName = "Ship To";

class Form extends Component {
  constructor(props) {
    super(props);
    var editID = this.props.location.state?.editID;
    this.state = {
      editID:
        editID !== "" &&
        typeof editID !== undefined &&
        typeof editID !== "undefined"
          ? editID
          : "",
      userID: userID(),
      postdata: {
        customerName: "",
        customerAddress1: "",
        customerAddress2: "",
        customerState: "",
        customerBranch: "",
        customerPincode: "",
        customerContactPerson: "",
        customerMobile: "",
        customerEmail: "",
        customerGSTNo: "",
        customerGSTCode: "",
        status: "",
      },
      brandList: [],
      detaildata: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    this.loadBrand();
    if (this.state.editID !== "") {
      var params = {
        params:
          "&userID=" + this.state.userID + "&detail_id=" + this.state.editID,
        url: module + "details",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push("/" + module);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      this.state.editID !== ""
    ) {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var customerStatus =
            result.customerStatus === "A" ? "Active" : "In Active";
          var status =
            result.customerStatus !== "" && result.customerStatus !== null
              ? {
                  label: customerStatus,
                  value: result.customerStatus,
                }
              : "";
          var clientupdatedata = {
            customerName: result.customerName,
            customerAddress1: result.customerAddress1,
            customerAddress2: result.customerAddress2,
            customerState: result.customerState,
            customerBranch: result.customerBranch,
            customerPincode: result.customerPincode,
            customerContactPerson: result.customerContactPerson,
            customerMobile: result.customerMobile,
            customerEmail: result.customerEmail,
            customerGSTNo: result.customerGSTNo,
            customerGSTCode: result.customerGSTCode,
            status: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push("/" + module);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  loadBrand() {
    var urlShringTxt =
      apiUrl + "brand/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ brandList: res.data.result });
      }
    });
  }
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      customerName: postData.customerName,
      customerAddress1: postData.customerAddress1,
      customerAddress2: postData.customerAddress2,
      customerState: postData.customerState,
      customerBranch: postData.customerBranch,
      customerPincode: postData.customerPincode,
      customerContactPerson: postData.customerContactPerson,
      customerMobile: postData.customerMobile,
      customerEmail: postData.customerEmail,
      customerGSTNo: postData.customerGSTNo,
      customerGSTCode: postData.customerGSTCode,
      status:
        Object.keys(postData.status).length > 0 ? postData.status?.value : "A",
      userID: this.state.userID,
    };

    var post_url = module + "add";
    if (this.state.editID !== "") {
      postObject["edit_id"] = this.state.editID;
      post_url = module + "update";
    }
    this.props.getFormPost(postObject, post_url, "add");
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="shipto" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={"/shipto"}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            brandList={this.state.brandList}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop:
                                        $(document)
                                          .find("#modulefrm .error:first")
                                          .offset().top - 100,
                                    },
                                    500
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, postType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, postType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const {
    customerName,
    customerAddress1,
    customerState,
    customerBranch,
    customerPincode,
    customerEmail,
    customerGSTNo,
    customerGSTCode,
    status,
  } = props.fields;

  return {
    fields: [
      "customerName",
      "customerAddress1",
      "customerState",
      "customerBranch",
      "customerPincode",
      "customerEmail",
      "customerGSTNo",
      "customerGSTCode",
      "status",
    ],
    validations: {
      customerName: [[isEmpty, customerName]],
      customerEmail: [[isEmail, customerEmail]],
      customerGSTNo: [[isEmpty, customerGSTNo]],
      customerGSTCode: [[isEmpty, customerGSTCode]],
      customerAddress1: [[isEmpty, customerAddress1]],
      customerState: [[isEmpty, customerState]],
      customerBranch: [[isEmpty, customerBranch]],
      customerPincode: [[isEmpty, customerPincode]],
      status: [[isSingleSelect, status]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
  }

  goBack() {
    this.props.history.push("/customer");
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgcustomerName,
      errMsgcustomerAddress1,
      errMsgcustomerState,
      errMsgcustomerBranch,
      errMsgcustomerPincode,
      errMsgcustomerEmail,
      errMsgcustomerGSTNo,
      errMsgcustomerGSTCode,
      errMsgStatus = "";

    if ($validation.customerName.error.reason !== undefined) {
      errMsgcustomerName = $validation.customerName.show && (
        <span className="error">{$validation.customerName.error.reason}</span>
      );
    }
    if ($validation.customerAddress1.error.reason !== undefined) {
      errMsgcustomerAddress1 = $validation.customerAddress1.show && (
        <span className="error">
          {$validation.customerAddress1.error.reason}
        </span>
      );
    }
    if ($validation.customerState.error.reason !== undefined) {
      errMsgcustomerState = $validation.customerState.show && (
        <span className="error">{$validation.customerState.error.reason}</span>
      );
    }
    if ($validation.customerBranch.error.reason !== undefined) {
      errMsgcustomerBranch = $validation.customerBranch.show && (
        <span className="error">{$validation.customerBranch.error.reason}</span>
      );
    }
    if ($validation.customerPincode.error.reason !== undefined) {
      errMsgcustomerPincode = $validation.customerPincode.show && (
        <span className="error">
          {$validation.customerPincode.error.reason}
        </span>
      );
    }
    if ($validation.customerEmail.error.reason !== undefined) {
      errMsgcustomerEmail = $validation.customerEmail.show && (
        <span className="error">{$validation.customerEmail.error.reason}</span>
      );
    }
    if ($validation.customerGSTNo.error.reason !== undefined) {
      errMsgcustomerGSTNo = $validation.customerGSTNo.show && (
        <span className="error">{$validation.customerGSTNo.error.reason}</span>
      );
    }
    if ($validation.customerGSTCode.error.reason !== undefined) {
      errMsgcustomerGSTCode = $validation.customerGSTCode.show && (
        <span className="error">
          {$validation.customerGSTCode.error.reason}
        </span>
      );
    }
    if ($validation.status.error.reason !== undefined) {
      errMsgStatus = $validation.status.show && (
        <span className="error">{$validation.status.error.reason}</span>
      );
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Name"
                name="customerName"
                value={fields.customerName}
                {...$field("customerName", (e) =>
                  onChange("customerName", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgcustomerName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Address1<span className="lbl-error">*</span>
              </label>

              <input
                type="text"
                className="form-control"
                placeholder="Address1"
                name="customerAddress1"
                value={fields.customerAddress1}
                {...$field("customerAddress1", (e) =>
                  onChange("customerAddress1", e.target.value)
                )}
              />
              {errMsgcustomerAddress1}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Address2</label>
              <input
                type="text"
                className="form-control"
                placeholder="Address2"
                name="customerAddress2"
                value={fields.customerAddress2}
                {...$field("customerAddress2", (e) =>
                  onChange("customerAddress2", e.target.value)
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                State<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="State"
                name="customerState"
                value={fields.customerState}
                {...$field("customerState", (e) =>
                  onChange("customerState", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgcustomerState}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Branch<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Branch"
                name="customerBranch"
                value={fields.customerBranch}
                {...$field("customerBranch", (e) =>
                  onChange("customerBranch", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgcustomerBranch}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Pin Code<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Pin Code"
                name="customerPincode"
                value={fields.customerPincode}
                {...$field("customerPincode", (e) =>
                  onChange("customerPincode", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgcustomerPincode}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Contact Person</label>
              <input
                type="text"
                className="form-control"
                placeholder="Contact Person"
                name="customerContactPerson"
                value={fields.customerContactPerson}
                {...$field("customerContactPerson", (e) =>
                  onChange("customerContactPerson", e.target.value)
                )}
                maxLength={255}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Mobile</label>
              <input
                type="text"
                className="form-control"
                placeholder="Mobile"
                name="customerMobile"
                value={fields.customerMobile}
                {...$field("customerMobile", (e) =>
                  onChange("customerMobile", e.target.value)
                )}
                maxLength={255}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Email</label>
              <input
                type="text"
                className="form-control"
                placeholder="Email"
                name="customerEmail"
                value={fields.customerEmail}
                {...$field("customerEmail", (e) =>
                  onChange("customerEmail", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgcustomerEmail}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                GST No.<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="GST No."
                name="customerGSTNo"
                value={fields.customerGSTNo}
                {...$field("customerGSTNo", (e) =>
                  onChange("customerGSTNo", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgcustomerGSTNo}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                GST Code<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="GST Code"
                name="customerGSTCode"
                value={fields.customerGSTCode}
                {...$field("customerGSTCode", (e) =>
                  onChange("customerGSTCode", e.target.value)
                )}
                maxLength={255}
              />
              {errMsgcustomerGSTCode}
            </div>

            <div className="form-group col-md-3">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.status}
                onChange={this.handleSelectChange.bind(this, "status")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div
              className="btn-group me-2 sw-btn-group-extra submit_frm"
              role="group"
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Submit
              </button>

              <button
                className="btn btn-secondary"
                onClick={this.goBack.bind(this)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
